<template>
  <div class="container">
    <div class="afterGoods">
      <div class="goods_title">退货商品</div>
      <el-table border
        style="width:100%"
        :data="goodsData"
        :cell-style="tc"
        :header-cell-style="tccolor"
        size="mini">
        <el-table-column label="商品图片">
          <template slot-scope="scope">
            <img style="width:36px;height:36px;"
              :src="scope.row.img_url" />
          </template>
        </el-table-column>
        <el-table-column label="商品名称"
          prop="title"></el-table-column>
        <el-table-column label="来源/供应商">
          <template slot-scope="scope">
            <p v-if="detail.supply_name">来源: {{ detail.supply_name }}</p>
            <p v-else>---</p>
            <p v-if="scope.row.supplier_name">
              供应商: {{ scope.row.supplier_name }}
            </p>
            <p v-else>---</p>
          </template></el-table-column>
        <el-table-column label="接入方式">
          <template slot-scope="scope">
            <p v-if="scope.row.product_cate">
              {{ scope.row.product_cate }}
            </p>
            <p v-else>---</p>
          </template>
        </el-table-column>
        <el-table-column label="规格属性"
          prop="attribute"></el-table-column>
        <el-table-column label="数量">
          <template slot-scope="scope">
            <p v-if="scope.row.quantity">{{ scope.row.quantity }}件</p>
            <p v-else>---</p>
          </template>
        </el-table-column>
        <el-table-column label="价格">
          <template slot-scope="scope">
            <p v-if="scope.row.unit_price">
              供货价: ¥{{ scope.row.unit_price }}
            </p>
            <p v-else>---</p>

            <p v-if="scope.row.cost_price">
              成本价: ¥{{ scope.row.cost_price }}
            </p>
            <p v-else>---</p>
          </template>
        </el-table-column>
        <el-table-column label="收益预估">
          <template slot-scope="scope">
            <p v-if="
								scope.row.unit_price &&
									scope.row.cost_price &&
									scope.row.quantity
							">
              ¥
              {{
								(
									(Number(scope.row.unit_price) -
										Number(scope.row.cost_price)) *
									Number(scope.row.quantity)
								).toFixed(2)
							}}
            </p>
            <p v-else>---</p>
          </template>
        </el-table-column>
      </el-table>

      <!--v-if="goodsData.length > 0"-->
      <div class="total_profit"
        v-if="goodsData.length > 0">
        <span v-if="goodsData[0].unit_price && goodsData[0].quantity"
          style="color:#f4222d;">¥
          {{
						(
							Number(goodsData[0].unit_price) * Number(goodsData[0].quantity)
						).toFixed(2)
					}}</span>
        <span>合计:</span>
      </div>
    </div>

    <div class="aftesaleInfo">
      <div class="goods_title">
        说明：订单退还成功后，分销渠道的扣款将会返还，未发货订单支持退还运费，已发货订单不支持退还运费
        <el-button v-if="detail.status == 1"
          size="mini"
          style="float:right;margin-right:12px;margin-top:16px;"
          @click="safeguardSl(1)">维权受理</el-button>
        <el-button v-if="detail.status == 2"
          size="mini"
          style="float:right;margin-right:12px;margin-top:16px;"
          @click="safeguardSl(2)">维权确认</el-button>
      </div>

      <div class="order_base_info">
        <i class="el-icon-collection-tag"></i>
        <span class="top_title">维权申请信息</span>
      </div>
      <table border
        class="after_table">
        <tr>
          <td>订单编号</td>
          <td>
            {{ detail.order_no }}
            <!--v-if="detail.status != 1"-->
            <span class="watch_order"
              v-if="detail.status != 1"
              @click="gotoOrderDetail(detail.order_id)">查看订单</span>
          </td>
        </tr>
        <tr>
          <td>维权状态</td>
          <td>
            <p v-if="detail.status == 0">无</p>
            <p v-if="detail.status == 1"
              style="color:rgb(253,164,41)">
              维权申请中
            </p>
            <p v-if="detail.status == 2"
              style="color:rgb(253,164,41)">
              维权受理中
            </p>
            <p v-if="detail.status == 3"
              style="color:rgb(253,164,41)">
              处理完成
            </p>
            <p v-if="detail.status == 4"
              style="color:#f4222d;">已拒绝</p>
          </td>
        </tr>
        <tr>
          <td>订单状态</td>
          <td>
            <p v-if="detail.order_status == 0">
              待支付
            </p>
            <p v-if="detail.order_status == 1">
              待发货
            </p>
            <p v-if="detail.order_status == 2">
              已发货
            </p>
            <p v-if="detail.order_status == 6">
              已签收
            </p>
            <p v-if="detail.order_status == 7">
              已收获
            </p>
            <p v-if="detail.order_status == 3">
              已取消
            </p>
            <p v-if="detail.order_status == 4">
              已完成
            </p>
            <p v-if="detail.order_status == 5">
              已关闭
            </p>
          </td>
        </tr>
        <tr>
          <td>申请时间</td>
          <td>{{ detail.created_at }}</td>
        </tr>
        <tr>
          <td>用户账号</td>
          <td>
            <p v-if="detail.contact_phone">{{ detail.contact_phone }}</p>
            <p v-else>---</p>
          </td>
        </tr>
        <tr>
          <td>联系人</td>
          <td>
            <p v-if="detail.contact_name">{{ detail.contact_name }}</p>
            <p v-else>---</p>
          </td>
        </tr>
        <tr>
          <td>联系电话</td>
          <td>
            <p v-if="detail.contact_phone">{{ detail.contact_phone }}</p>
            <p v-else>---</p>
          </td>
        </tr>
        <tr>
          <td>维权原因</td>
          <td>

            <span class='radio_label'
              v-if="detail.apply_reason_id==1">不喜欢/不想要/效果不好</span>

            <span class='radio_label'
              v-if="detail.apply_reason_id == 2">拍错了</span>
            <span class='radio_label'
              v-if="detail.apply_reason_id == 3">未按照约定时间发货</span>
            <span class='radio_label'
              v-if="detail.apply_reason_id == 4">质量问题</span>
            <span class='radio_label'
              v-if="detail.apply_reason_id == 5">颜色/样式/尺寸大小与描述不符</span>
            <span class='radio_label'
              v-if="detail.apply_reason_id == 6">卖家发错货</span>
            <span class='radio_label'
              v-if="detail.apply_reason_id == 7">配件破损</span>
            <span class='radio_label'
              v-if="detail.apply_reason_id == 8">主商品破损</span>
            <span class='radio_label'
              v-if="detail.apply_reason_id == 9">其他</span>

            <!-- <span v-else>---</span> -->
          </td>
        </tr>
        <tr>
          <td>问题描述</td>
          <td>
            <p v-if="detail.apply_reason">{{ detail.apply_reason }}</p>
            <p v-else>---</p>
          </td>
        </tr>
        <tr>
          <td>凭证照片</td>
          <td>
            <img style="width:42px;height:42px;margin-right:24px;"
              v-for="(item, index) in imgs"
              :src="item"
              :key="'g' + index" />
          </td>
        </tr>
      </table>

      <!--维权处理信息-->
      <div class="order_base_info"
        v-if="detail.status != 1">
        <i class="el-icon-collection-tag"></i>
        <span class="top_title">维权处理信息</span>
      </div>

      <table border
        class="after_table"
        v-if="detail.status != 1">
        <tr>
          <td>订单金额</td>
          <td>
            <span v-if="product_info.unit_price && product_info.quantity"
              style="color:#f4222d;">¥
              {{
								(
									Number(product_info.unit_price) *
									Number(product_info.quantity)
								).toFixed(2)
							}}</span>
          </td>
        </tr>
        <!-- <tr>
					<td>维权类型</td>
					<td></td>
				</tr> -->
        <tr>
          <td>确认退款金额</td>
          <td>
            <p v-if="detail.status == 4 || detail.status == 3">{{detail.refund_money}}</p>
            <p v-else>待确认</p>
          </td>
        </tr>
        <!-- <tr>
          <td>退换货收获地址</td>
          <td></td>
        </tr> -->
        <tr>
          <td>退换货收货人姓名</td>
          <td>
            <p v-if="detail.contact_name">{{detail.contact_name}}</p>
            <p v-else>---</p>
          </td>
        </tr>
        <tr>
          <td>联系电话</td>
          <td>
            <p v-if="detail.contact_phone">{{ detail.contact_phone }}</p>
            <p v-else>---</p>
          </td>
        </tr>
        <tr v-if="detail.status == 4">
          <td>拒绝原因</td>
          <td>
            <p v-if="detail.remark">{{ detail.remark }}</p>
            <p v-else>---</p>
          </td>
        </tr>
      </table>

      <!--除了待处理不显示,其余都显示-->
      <div class="order_base_info">
        <i class="el-icon-collection-tag"></i>
        <span class="top_title">操作备注</span>
      </div>
      <!--操作备注   除了待处理不显示,其余都显示-->
      <el-table border
        style="width:90%;margin: 20px 28px;"
        :data="remarkData"
        :cell-style="tc"
        :header-cell-style="tccolor"
        size="mini">
        <el-table-column label="操作者">
          <template slot-scope="scope">
            <p v-if="scope.row.operator">{{ scope.row.operator }}</p>
          </template>
        </el-table-column>
        <el-table-column label="操作时间"
          prop="created_at"></el-table-column>
        <el-table-column label="备注"
          prop="remark"></el-table-column>
      </el-table>

      <div class="order_base_info">
        <i class="el-icon-collection-tag"></i>
        <span class="top_title">订单备注</span>
      </div>
      <table border
        class="remark_table">
        <tr>
          <td>处理备注</td>
          <td>
            <el-input size="mini"
              style="width:72%;margin-left:24px;"
              placeholder="请输入处理备注"
              v-model="remark"></el-input>

            <el-button size="mini"
              style="float:right;margin-right:12px;"
              type="primary"
              @click="updateAfterRemark">更新备注</el-button>
          </td>
        </tr>
      </table>
    </div>

    <gydialog :title="guardtitle"
      :visible.sync="showSafeguard"
      width="640px">
      <table border
        class="after_table">
        <tr>
          <td>订单金额</td>
          <td>
            <span v-if="product_info.unit_price && product_info.quantity"
              style="color:#f4222d;">¥
              {{
								(
									Number(product_info.unit_price) *
									Number(product_info.quantity)
								).toFixed(2)
							}}</span>
          </td>
        </tr>
        <tr>
          <td>确认退款金额</td>
          <td>
            <el-input size="mini"
              style="width:240px;float:left;"
              v-model="shouliForm.refund_money"
              placeholder="请输入退款金额"></el-input>
          </td>
        </tr>
        <tr>
          <td>维权备注</td>
          <td>
            <el-input type="textarea"
              :rows="3"
              style="width:300px;float:left;"
              placeholder="请输入内容"
              v-model="shouliForm.remark">
            </el-input>
          </td>
        </tr>
      </table>

      <div style="margin:18px 20px;height:40px;">
        <el-button size="mini"
          @click="beginHandle"
          style="float:right;margin-right:12px;"
          type="warning"
          v-if="detail.status == 1">开始受理</el-button>
        <el-button size="mini"
          @click="certainHandle"
          v-if="detail.status == 2"
          style="float:right;margin-right:12px;"
          type="warning">确认维权</el-button>
        <el-button size="mini"
          @click="rejectSafeGuard"
          style="float:right;margin-right:12px;"
          type="danger">拒绝维权</el-button>
      </div>
    </gydialog>
  </div>
</template>

<script>
import {
  afterSaleDetail,
  afterSaleRemarkInsert,
  afterSaleRemarksList,
  handleApplySale
} from '@/api/order'
import store from '@/store/index'
export default {
  data () {
    return {
      orderId: '',
      detail: {},
      goodsData: [],
      remarkData: [],
      imgs: [],
      userId: '',
      remark: '',

      //维权受理类型
      showSafeguard: false,
      //维权受理   维权确认
      guardtitle: '维权受理',
      product_info: {},
      shouliForm: {
        status: '',
        refund_money: '',
        after_sale_product_id: '',
        remark: ''
      }
    }
  },
  activated () {
    this.orderId = this.$route.query.orderId
    this.userId = store.getters.userId
    if (this.orderId) {
      this.afterSaleDetailInfo()
      this.afterSaleRemarksListData()
    }
  },

  methods: {
    //获取维权订单详情
    async afterSaleDetailInfo () {
      this.goodsData = []
      let res = await afterSaleDetail({ id: this.orderId })

      this.detail = res
      this.product_info = res.product_info
      if (res.product_info) {
        this.goodsData.push(res.product_info)
      }

      if (res.imgs) {
        this.imgs = res.imgs
      }
    },

    //跳转订单详情
    gotoOrderDetail (id) {
      this.$router.push({
        path: './detail',
        query: {
          orderId: id
        }
      })
    },
    safeguardSl (type) {
      //1.受理  2.确认
      if (type == 1) {
        this.title = '维权受理'
      } else {
        this.title = '维权确认'
      }

      this.showSafeguard = true
    },
    updateAfterRemark () {
      if (!this.remark) {
        this.$message.error('备注不能为空')
        return
      } else {
        this.afterSaleRemarkInsertData()
      }
    },
    //更新备注
    async afterSaleRemarkInsertData () {
      var form = {
        order_after_sale_id: this.detail.id,
        after_sale_product_id: this.detail.order_product_id,
        remark: this.remark,
        operator: this.userId
      }
      let res = await afterSaleRemarkInsert(form)
      this.$message.success('更新备注成功')
      this.remark = ''
      console.log(res)
      this.afterSaleRemarksListData()
    },
    //维权订单备注列表
    async afterSaleRemarksListData () {
      let res = await afterSaleRemarksList(this.orderId)
      this.remarkData = res
    },
    //开始受理
    beginHandle () {
      if (Number(this.shouliForm.refund_money) <= 0) {
        this.$message.error('退款金额不能低于0')
        return
      }
      if (!this.shouliForm.remark) {
        this.$message.error('备注不能为空')
        return
      }
      this.shouliForm.status = 2
      this.shouliForm.after_sale_product_id = this.orderId
      this.handleApplySaleData()
    },
    //确认维权
    certainHandle () {
      if (Number(this.shouliForm.refund_money) <= 0) {
        this.$message.error('退款金额不能低于0')
        return
      }
      if (!this.shouliForm.remark) {
        this.$message.error('备注不能为空')
        return
      }
      this.shouliForm.status = 3
      this.shouliForm.after_sale_product_id = this.orderId
      this.handleApplySaleData()
    },
    //拒绝维权
    rejectSafeGuard () {
      if (!this.shouliForm.remark) {
        this.$message.error('备注不能为空')
        return
      }
      this.shouliForm.status = 4
      this.shouliForm.after_sale_product_id = this.orderId
      this.handleApplySaleData()
    },
    //维权申请处理
    async handleApplySaleData () {
      let res = await handleApplySale(this.shouliForm)
      console.log(res)
      this.$message.success('处理成功')
      this.handleSuccess()
      this.afterSaleDetailInfo()
      this.afterSaleRemarksListData()
      this.showSafeguard = false
    },
    //处理成功
    handleSuccess () {
      this.shouliForm = {
        status: '',
        refund_money: '',
        after_sale_product_id: '',
        remark: ''
      }
    },
    tc () {
      return 'text-align:center;'
    },
    tccolor () {
      return 'text-align:center;background-color:#f5f5f5; font-size:14px;font-weight:500;color:rgb(102,102,102);'
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
	padding: 20px 36px;
	.afterGoods {
		border: 1px solid rgb(228, 228, 228);
	}
	.goods_title {
		background-color: rgb(243, 243, 243);
		height: 60px;
		line-height: 60px;
		text-align: left;
		padding-left: 20px;
		color: #666;
		font-size: 13px;
	}
	.total_profit {
		background-color: rgb(240, 242, 245);
		height: 42px;
		line-height: 42px;
		span {
			float: right;
			margin-right: 12px;
			font-weight: 500;
			font-size: 16px;
		}
	}

	.aftesaleInfo {
		border: 1px solid rgb(228, 228, 228);
		margin-top: 24px;
	}
	.after_table {
		border: 1px solid rgb(228, 228, 228);
		margin: 20px 28px;
		border-collapse: collapse;
		width: 90%;
		tr {
			height: 48px;
			td {
				border: 1px solid rgb(228, 228, 228);
				padding: 10px;
				font-size: 13px;
			}
			td:first-child {
				background-color: rgb(240, 242, 245);
				width: 160px;
				text-align: right;
				padding-right: 24px;
				font-weight: 500;
			}
			td:last-child {
				text-align: left;
				padding-left: 24px;
			}
		}
		tr:last-child {
			height: 72px;
		}
	}
	.watch_order {
		cursor: pointer;
		color: rgb(253, 164, 41);
		margin-left: 24px;
	}
	.remark_table {
		border: 1px solid rgb(228, 228, 228);
		margin: 20px 28px;
		border-collapse: collapse;
		width: 90%;
		tr {
			height: 48px;
			td {
				border: 1px solid rgb(228, 228, 228);
				padding: 10px;
			}
			td:first-child {
				background-color: rgb(240, 242, 245);
				width: 140px;
				text-align: right;
				padding-right: 24px;
				font-weight: 500;
				font-size: 13px;
			}
			td:last-child {
				text-align: left;
			}
		}
	}
	.order_base_info {
		margin: 36px 20px 0 20px;
		overflow: hidden;
		i {
			color: rgb(51, 51, 51);
			float: left;
			margin-top: 4px;
			font-size: 20px;
			font-weight: 500;
		}
		.top_title {
			float: left;
			font-weight: 500;
			font-size: 18px;
		}
	}
}
</style>
